import { useState, useEffect, useMemo } from "react";
import { debounce } from "../utils/debounce";

export enum Devices {
  DESKTOP = "desktop",
  SMALLDESKTOP = "smallDesktop",
  TABLET = "tablet",
  MOBILE = "mobile",
  }
export type ViewportSizeType = `${Devices}`;

/**
 * @param debounceTime - In Milliseconds. Amount of time that the hook does not register another window resize.
 * @returns
 */
export function useViewport(debounceTime: number) {
  const [width, setWidth] = useState<ViewportSizeType>(undefined);

  const memoizedHandler = useMemo(
    () =>
      function handleResize() {
        if (window.innerWidth < 470) setWidth(Devices.MOBILE);
        if (window.innerWidth >= 470 && window.innerWidth < 1024)
          setWidth(Devices.TABLET);
        if (window.innerWidth >= 1024 && window.innerWidth < 1440) setWidth(Devices.SMALLDESKTOP);
        if (window.innerWidth >= 1440) return setWidth(Devices.DESKTOP);
      },
    []
  );

  const debouncedEventHandler = debounce(memoizedHandler, debounceTime);

  useEffect(() => {
    debouncedEventHandler();
    window.addEventListener("resize", debouncedEventHandler);

    return () => window.removeEventListener("resize", debouncedEventHandler);
  }, []);

  return width;
}
